<template>
  <MDBCard class="py-0 border-0">
    <CategoryTop :title="$t('global.nav.payouts')" :breadcrumbs-parent-routes="['account']"
      :description="$t('global.payoutsDescription')" content-class="px-4 mt-4" leftCol="12" rightCol="0" />

    <MDBRow>
      <MDBCol cols="12" class="mb-3">
        <div class="payout-summary p-3">
          <div v-if="yearlyPayoutItems.length" class="fw-bold">
            <div v-for="(payout, index) in yearlyPayoutItems" :key="index"
              class="font-16 text-dark-gray d-flex justify-content-between align-items-center pt-3">
              <div>
                <span>{{ payout.year }}: &euro; {{ formatAmount(payout.amount) }}</span>
                {{ $t("global.paidOut") }}
              </div>

              <button
                type="button"
                class="btn btn-primary"
                @click="openPayoutPdf(payout.year)"
              >
                {{ $t("global.buttons.openBonusPayout", $t("global.buttons.readNow")) }}
              </button>
            </div>
          </div>
          <div v-else class="font-16 text-dark-gray">
            {{ $t("bankstatement.noDataFound") }}
          </div>
        </div>
      </MDBCol>
    </MDBRow>
  </MDBCard>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { MDBCard, MDBRow, MDBCol } from "mdb-vue-ui-kit";
import CategoryTop from "@/components/General/CategoryTop/index.vue";
import axios from "axios";

const store = useStore();
const user = computed(() => store.getters.getMe);
const yearlyPayoutItems = computed(() => {
  const payouts = user.value?.payouts;
  const rawItems = Array.isArray(payouts)
    ? payouts
    : payouts && typeof payouts === "object"
      ? [payouts]
      : [];

  return rawItems
    .flatMap((item) => {
      if (!item || typeof item !== "object") return [];
      return Object.entries(item).map(([yearKey, amount]) => {
        const year = Number(String(yearKey).replace(":", ""));
        const numericAmount = Number(amount);
        return {
          year: Number.isNaN(year) ? null : year,
          amount: Number.isNaN(numericAmount) ? 0 : numericAmount,
        };
      });
    })
    .filter((item) => item.year !== null)
    .sort((a, b) => b.year - a.year);
});
const formatAmount = (value) => Number(value ?? 0).toFixed(2).replace(".", ",");
const buildPayoutPdfUrl = (year) => {
  const apiBaseUrl = String(axios.defaults.baseURL || "").replace(/\/$/, "");
  const userId = user.value?.plainId ?? user.value?.id;

  if (!apiBaseUrl || !userId || !year) {
    return null;
  }

  return `${apiBaseUrl}/generate-kickback-pdf?userId=${encodeURIComponent(userId)}&year=${encodeURIComponent(year)}`;
};

const openPayoutPdf = (year) => {
  const url = buildPayoutPdfUrl(year);
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};

store.dispatch("me");
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/points_overview.scss";

.payout-summary {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
</style>
